import { BaseThemeType, Link, styled } from 'opensolar-ui'

const LinkTitle = styled(Link, { name: 'LinkTitle' })((props: { theme: BaseThemeType }) => ({
  color: `${props.theme.palette.grey[900]} !important`,
  textDecoration: 'underline',
}))
const ResourcesLinks = ({ resource, onClick }) => {
  return (
    <>
      <LinkTitle
        key={'resource-' + resource.id}
        href={resource.url}
        target="_blank"
        download={'expo_resource'}
        onClick={onClick}
      >
        {resource.title}
      </LinkTitle>
    </>
  )
}
export default ResourcesLinks
